module.exports = __webpack_public_path__ + "img/banner_lay.6e4a99ea.png";